import { Link, Text} from '@chakra-ui/react'

const ButtonMailto = ({ mailto, label }) => {
    return (
        <Link
            to='#'
            onClick={(e) => {
                window.location.href = mailto;
                e.preventDefault();
            }}
        >
            <Text as={'span'} color={'blue.400'}>{label}</Text>
        </Link>
    );
};

export default ButtonMailto;